// Build-time (SSG) data access. During prerendering the build script fills
// globalThis.__SSG_DATA__ so components can render real content without JS.
export const ssgData = (key) =>
  (typeof globalThis !== "undefined" && globalThis.__SSG_DATA__
    ? globalThis.__SSG_DATA__[key]
    : undefined);
